import React from 'react';
import { Folders } from 'modules/Administration/Folders/Folders';

const ViewFolders: React.FC = () => <Folders action="view" />;

export default ViewFolders;
